module.exports = __webpack_public_path__ + "static/media/icon-br.a6f0b957.svg";